import { useEffect } from 'react'
import { select } from '@/store'
import { useSelector, useDispatch } from '@/hooks/redux'
import useCurrentSession from '@/hooks/use-current-session'
import type { Contract } from '@/features/Pad'

type ContractProps = {
  contracts: Contract[]
  sent: Contract[]
}

const empty: ContractProps = { contracts: [], sent: [] }

const usePadContracts = (enabled = true) => {
  const dispatch = useDispatch()
  const session = useCurrentSession()
  const userId = session.id
  const padContracts: ContractProps = useSelector(state =>
    (select.contract.userPadEnabledContracts as any)(state, { userId })
  )
  useEffect(() => {
    if (!enabled) return
    dispatch.contract.getContracts()
  }, [dispatch.contract, enabled])
  return enabled ? padContracts : empty
}

export default usePadContracts
